@import "../../../global/gx-ide-common.scss";
@import "../../../global/gx-ide-mixins.scss";
@import "../../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: grid;
  block-size: 100%;
  grid-template-rows: 1fr max-content;
}

.section {
  display: contents;
}

.main {
  contain: size;
  overflow: auto;
}

.list-box {
  block-size: 100%;
}
